import clsx from 'clsx';
import React from 'react';

import { cn } from '@/src/util/ui';

type LabelProps = {
  label;
  required?: boolean;
  mainContainerClasses?: string;
  labelClasses?: string;
  htmlFor?: string;
  children?: React.ReactNode;
};

const Label = ({
  label,
  required = false,
  mainContainerClasses,
  labelClasses,
  htmlFor,
  children,
}: LabelProps) => {
  return (
    <div className={cn('tw-flex tw-items-center', mainContainerClasses)}>
      <label
        htmlFor={htmlFor ? htmlFor : label}
        className={cn(
          // (!) is not removed here as it is to override the styles from vendor.css
          '!tw-mb-0',
          'tw-font-brandonTextMedium tw-text-cfo-grey-600 !tw-font-normal',
          labelClasses
        )}
      >
        {label}

        {required && (
          <sup className={clsx('tw-top-[-2px]', 'tw-text-[15px] tw-text-cfo-red-400')}>*</sup>
        )}
      </label>
      {children}
    </div>
  );
};

export default Label;
